import { render, staticRenderFns } from "./AvatarList.vue?vue&type=template&id=6ef25cb2&scoped=true&"
import script from "./AvatarList.vue?vue&type=script&lang=js&"
export * from "./AvatarList.vue?vue&type=script&lang=js&"
import style0 from "./AvatarList.vue?vue&type=style&index=0&id=6ef25cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef25cb2",
  null
  
)

export default component.exports